import { render, staticRenderFns } from "./TeamChallengeResult.vue?vue&type=template&id=2f49f748&scoped=true&"
import script from "./TeamChallengeResult.vue?vue&type=script&lang=js&"
export * from "./TeamChallengeResult.vue?vue&type=script&lang=js&"
import style0 from "./TeamChallengeResult.vue?vue&type=style&index=0&id=2f49f748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49f748",
  null
  
)

export default component.exports